import queryServerSideData from './queryServerSideData'

export default async function getUserTeamSeasonsData(session) {
  const data = []
  const seasonData = await queryServerSideData('qCalendarSeasons.graphql', {}, session.cookieString)
  if (!seasonData) throw new Error('empty')

  const seasonActiveId = parseInt(seasonData?.data?.activeSeason?.season?.[0].id)
  let activeSeasonIdEnabled = false
  let activeClubIdEnabled = false

  session?.teams.forEach((team) => {
    activeSeasonIdEnabled = team.season === seasonActiveId ? true : activeSeasonIdEnabled
    activeClubIdEnabled = team.season === seasonActiveId && team.clubId ? true : activeClubIdEnabled
  })

  data.seasonData = seasonData
  data.activeSeasonPresent = activeSeasonIdEnabled
  data.activeClubIdEnabled = activeClubIdEnabled
  return data
}
